import { ProgramAndCoursesInfo } from "../../../../types/gqlTypes/graphql"
import { FiltersState } from "../../states"

export interface Column {
  label: string
  name: string
  sortableName?: string
  // Name of description field or function-getter
  description?: string | ((record: TableRecordType) => React.ReactNode)
  sortable?: boolean
  // Show/hide column based on filters state.
  filter?: (filters: FiltersState) => boolean
  type?:
    | "number"
    | "percent"
    | "duration"
    | "chip"
    | "link"
    | "trend"
    | "horizontalProgress"
    | "circleProgress"
    | "achievementLevel"
    | "correct"
    | "contentType"
    | "usageContentType"
    | "dateTime"
    | "utcdate"
    | "localDate"
    | "activity"
    | "correctPercent"
    | "correctAnswers"
    | "reportingCategory"
    | "course"
    | "multipleItems"
  dateFormat?: string
  typeProp?: string | ((record: TableRecordType) => React.ReactNode)
  variant?: string | ((record: TableRecordType) => string)
  linkUrl?: string | ((record: TableRecordType) => React.ReactNode)
  linkTooltip?: string | ((record: TableRecordType) => React.ReactNode)
  formatter?: (
    record: TableRecordType,
    prop: string,
    context?: { programsAndCourses?: ProgramAndCoursesInfo[] }
  ) => React.ReactNode
  // if empty or this property do not exist - item available for all content types
  // set ["default"] if this column exist in initial table
  columnContentTypes?: string[]
  columns?: Column[]
  size?: number
  canResize?: boolean
  tooltip?: React.ReactNode
  align?: "left" | "center" | "right"
  applySearchParams?: boolean
  diagonalHeader?: boolean
  mask?: boolean
}

export enum SortTypes {
  asc = "asc",
  desc = "desc"
}

export type Sorting = {
  sortBy: string
  order: SortTypes
}

export type SortHandler = (sortBy: string, order: SortTypes) => void

export type TableRecordType = {
  id: string
  sortableName?: string
  children?: TableRecordType[]
  [key: string]: any
}

export type SortProps = {
  sortBy?: string
  order?: SortTypes
  onSort?: (sortBy: string, order: SortTypes) => void
}

export type ScrollProps = {
  hasMoreItems?: boolean
  onFetch?: () => void
}
